import { HTTP_HEADER } from "src/models/constants";
import { getAccessToken } from "src/authentication-and-logging/authAndLogger";

const ApplicationTypeJson = "application/json";

export async function getHeaders() {
	const token = await getAccessToken();
	return {
		[HTTP_HEADER.Authorization]: `Bearer ${token}`,
		[HTTP_HEADER.ContentType]: ApplicationTypeJson,
	};
}
